export default "__VITE_ASSET__c988cb26__"